var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"nav-footer"},[_c('ul',{staticClass:"nav-footer__list"},_vm._l((_vm.data),function(item,index){return _c('li',{key:index,staticClass:"nav-footer__item"},[_c('a',{staticClass:"nav-footer__link",attrs:{"href":item.link,"target":item.blank ? '_blank' : false},domProps:{"innerHTML":_vm._s(item.name)}})])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }